
import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,

} from "reactstrap";

import { INPUT } from "Auth/config";
import { start } from 'service'



import { sedes } from 'assets/img/logo';
import { API_ENDPOINTS } from "../api";
import toast from "react-hot-toast";
import { Select1, InputUsuario, CabeceraFormulariosTratamientoLista } from "../input/elementos";
import { Select1EasyColors } from "components/input/elementos";

const ExcelJS = require('exceljs')

export default function ReportesDiagnosticoDepartamental() {



  const [listaCronicoCongenito, setCronicoCongenito] = useState([]);
  const [listaItemsDiagnostico, setItemDiagnostico] = useState([]);
  const [listaGrupoEtario, setListaGrupoEtario] = useState([]);
  const [listaTipoPaciente, setListaTipoPaciente] = useState([])
  const [listaMunicipios, setListaMunicipios] = useState([]);

  const [sangreTotal, setSangreTotal] = useState({ campo: null, valido: null });

  const [sexo, setSexo] = useState({ campo: null, valido: null });

  const [realizados, setRealizados] = useState({ campo: null, valido: null });
  const [inputBuscar, setInputBuscar] = useState({ campo: null, valido: null });
  const [inputBuscar2, setInputBuscar2] = useState({ campo: null, valido: null });
  const [idGrupo, setIdGrupo] = useState({ campo: null, valido: null });
  const [idGrupoEtario, setIdGrupoEtario] = useState({ campo: null, valido: null });
  const [idItem, setIdItem] = useState({ campo: null, valido: null });
  const [idMunicipio, setIdMunicipio] = useState({ campo: 1000000, valido: 'true' });
  const [nivel, setNivel] = useState({ campo: 1000000, valido: 'true' });


  const [idTipoPaciente, setIdTipoPaciente] = useState({ campo: null, valido: null });
  const [idPreQuirurgico, setIdPreQuirurgico] = useState({ campo: null, valido: null });
  const [idPostTratamiento, setIdPostTratamiento] = useState({ campo: null, valido: null });


  useEffect(() => {
    document.title = "REPORTES DIAGNOSTICO";
    listarParametroTipoConsulta()
    return () => { }
  }, [])

  const listarParametroTipoConsulta = async () => {
    const data = await start(API_ENDPOINTS.DIAGNOSTICO.PARAMETROS_REPORTES_D)
    setItemDiagnostico(data[0])
    setCronicoCongenito(data[1])
    setListaTipoPaciente(data[2])
    setListaMunicipios(data[3])

  };

  const listarGrupoEtario = async (id) => {
    const data = await start(API_ENDPOINTS.DIAGNOSTICO.LISTAR_GRUPO_ETARIO_REPORTES_D, { id_grupo: id })
    setListaGrupoEtario(data)
  }

  const buscarPorHospital = async () => {
    const loadingToast = toast.loading('Buscando información...');
    const data = await start(API_ENDPOINTS.DIAGNOSTICO.GENERAR_REPORTES_D, {
      fecha1: inputBuscar.campo,
      fecha2: inputBuscar2.campo,
      idMunicipio: idMunicipio.campo,
      nivel: nivel.campo,
      grupo: idGrupo.campo,
      grupoEtario: idGrupoEtario.campo,
      itemDiagnostico: idItem.campo,
      idTipoPaciente: idTipoPaciente.campo,
      idPreQuirurgico: idPreQuirurgico.campo,
      idPostTratamiento: idPostTratamiento.campo,
      tipo_de_muestra: sangreTotal.campo,
      realizados:realizados.campo,
      sexo: sexo.campo,
    })
    toast.dismiss(loadingToast);
    listarExcel(data)
  }




  const listarExcel = async (lista) => {

    if (lista.length > 0) {
      const workbook = new ExcelJS.Workbook();
      workbook.creator = 'gustavo aguilar torres CEL 71166513';
      workbook.lastModifiedBy = 'gustavo aguilar torres';

      const principal = workbook.addWorksheet('BASE DE DATOS', {
        properties:
        {
          tabColor: { argb: '1bbec0 ' }, showGridLines: false
        },
        pageSetup: {
          paperSize: 9, orientation: 'landscape'
        },

      })

      for (let index = 1; index < 1000; index++) {
        principal.getColumn(index).width = 10
      }

      principal.columns.forEach((column) => {
        column.alignment = { vertical: 'middle', wrapText: true }
        column.font = { name: 'Arial', color: { argb: '595959' }, family: 2, size: 9, italic: false }
      })
      principal.mergeCells("A1:C5");

      const imageId = workbook.addImage({
        base64: sedes,
        extension: 'png',
      })


      // CONFIGURACION DE LOS TIRULOS, NOMBRE HOSPITAL, MESES Y GESTION
      principal.addImage(imageId, { tl: { col: 0.6, row: 0.1 }, ext: { width: 200, height: 95 } })
      principal.mergeCells('E1:N1');
      principal.getCell('E1').alignment = { vertical: 'center', horizontal: 'center' };
      principal.getCell("E1").font = { bold: 600, size: 11, color: { argb: "595959" }, italic: false, };
      principal.getCell('E1').value = ''
      principal.mergeCells('E2:N2');
      principal.getCell("E2").font = { bold: 600, size: 11, color: { argb: "595959" }, italic: false, };
      principal.getCell('E2').alignment = { vertical: 'center', horizontal: 'center' };
      principal.getCell('E2').value = ' AREA ETVS SEDES CH'
      principal.mergeCells('E3:N3');
      principal.getCell("E3").font = { bold: 600, size: 11, color: { argb: "595959" }, italic: false, };
      principal.getCell('E3').alignment = { vertical: 'center', horizontal: 'center' };
      principal.getCell('E3').value = 'LISTA DE DIAGNISTICOS DE PACIENTES CON CHAGAS'


      principal.mergeCells('E5:H5');
      principal.getCell('E5').value = 'CANT. SOLICITUDES .' + lista.length
      principal.getCell('E5').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, }
      principal.getCell('E5').alignment = { horizontal: 'left', wrapText: true }
      principal.getCell('E5').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('E5').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('I5:Q5');
      principal.getCell('I5').value = 'CANT. ITEMS PROCESADOS EN LABORATORIO :' + lista.reduce((acumulador, valorActual) => acumulador + valorActual.cantidad_items_procesados, 0);
      principal.getCell('I5').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' }, }
      principal.getCell('I5').alignment = { horizontal: 'left', wrapText: true }
      principal.getCell('I5').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('I5').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };



      principal.mergeCells('A6:A7');
      principal.getCell('A6').value = 'N°'
      principal.getCell('A6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('A6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('A6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('A6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('B6:B7');
      principal.getCell('B6').value = 'RED SOLICITANTE'
      principal.getCell('B6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('B6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('B6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('B6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('C6:C7');
      principal.getCell('C6').value = 'MUNICIPIO SOLICITANTE'
      principal.getCell('C6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('C6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('C6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('C6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('D6:D7');
      principal.getCell('D6').value = 'EST. DE SALUD SOLICITANTE'
      principal.getCell('D6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('D6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('D6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('D6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('E6:F7');
      principal.getCell('E6').value = 'MEDICO SOLICITANTE'
      principal.getCell('E6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('E6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('E6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('E6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('G6:G7');
      principal.getCell('G6').value = 'FECHA SOLICITUD'
      principal.getCell('G6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('G6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('G6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('G6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('H6:H7');
      principal.getCell('H6').value = 'PACIENTE'
      principal.getCell('H6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('H6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('H6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('H6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('I6:I7');
      principal.getCell('I6').value = ' EDAD AÑOS'
      principal.getCell('I6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('I6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('I6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('I6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('J6:J7');
      principal.getCell('J6').value = 'EDAD MESES'
      principal.getCell('J6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('J6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('J6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('J6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('K6:K7');
      principal.getCell('K6').value = 'EDAD DIAS'
      principal.getCell('K6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('K6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('K6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('K6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('L6:L7');
      principal.getCell('L6').value = 'GRUPO ETARIO'
      principal.getCell('L6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('L6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('L6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('L6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('M6:M7');
      principal.getCell('M6').value = 'GRUPO ETARIO EDADES'
      principal.getCell('M6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('M6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('M6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('M6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };



      principal.mergeCells('N6:N7');
      principal.getCell('N6').value = 'RED LABORATORIO'
      principal.getCell('N6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('N6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('N6').font = { size: 7, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('N6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('O6:O7');
      principal.getCell('O6').value = 'MUNICIPIO LABORATORIO'
      principal.getCell('O6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('O6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('O6').font = { size: 7, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('O6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };


      principal.mergeCells('P6:P7');
      principal.getCell('P6').value = 'LABORATORIO'
      principal.getCell('P6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('P6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('P6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('P6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };


      principal.mergeCells('Q6:Q7');
      principal.getCell('Q6').value = 'LABORATORISTA'
      principal.getCell('Q6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('Q6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('Q6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('Q6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };


      principal.mergeCells('R6:R7');
      principal.getCell('R6').value = 'ITEM SOLICITADO'
      principal.getCell('R6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('R6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('R6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('R6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('S6:S7');
      principal.getCell('S6').value = 'FECHA TOMA MUESTRA'
      principal.getCell('S6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('S6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('S6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('S6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };



      principal.mergeCells('T6:U7');
      principal.getCell('T6').value = 'TIPO DE MUESTRA'
      principal.getCell('T6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('T6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('T6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('T6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };




      principal.mergeCells('V6:X7');
      principal.getCell('V6').value = 'CONCLUSION'
      principal.getCell('V6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('V6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('V6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('V6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      // principal.mergeCells('V6:V7');
      // principal.getCell('V6').value = 'POSITIVO'
      // principal.getCell('V6').alignment = { horizontal: 'center', wrapText: true }
      // principal.getCell('V6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      // principal.getCell('V6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      // principal.getCell('V6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };



      // principal.mergeCells('W6:W7');
      // principal.getCell('W6').value = 'NEGATICO'
      // principal.getCell('W6').alignment = { horizontal: 'center', wrapText: true }
      // principal.getCell('W6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      // principal.getCell('W6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      // principal.getCell('W6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      // principal.mergeCells('X6:X7');
      // principal.getCell('X6').value = 'INDETERMINADO'
      // principal.getCell('X6').alignment = { horizontal: 'center', wrapText: true }
      // principal.getCell('X6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      // principal.getCell('X6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      // principal.getCell('X6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('Y6:Y7');
      principal.getCell('Y6').value = 'FEHA REGISTRO RESULTADOS'
      principal.getCell('Y6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('Y6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('Y6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('Y6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('Z6:Z7');
      principal.getCell('Z6').value = 'FECHA ULTIMA ACTUALIZACION RESULTADOS'
      principal.getCell('Z6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('Z6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('Z6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('Z6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('AA6:AA7');
      principal.getCell('AA6').value = 'PRE QUIRURGICO'
      principal.getCell('AA6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('AA6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('AA6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('AA6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('AB6:AC7');
      principal.getCell('AB6').value = 'POSITIVOS CONFIRMADOS'
      principal.getCell('AB6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('AB6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('AB6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('AB6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };




      principal.mergeCells('AD6:AF7');
      principal.getCell('AF6').value = 'OBSERVACIONES'
      principal.getCell('AF6').alignment = { horizontal: 'left', wrapText: true }
      principal.getCell('AF6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('AF6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('AF6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('AG6:AG7');
      principal.getCell('AG6').value = 'CODIGO'
      principal.getCell('AG6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('AG6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('AG6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('AG6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      principal.mergeCells('AH6:AH7');
      principal.getCell('AH6').value = 'CANT. ITEMS PROCESADOS'
      principal.getCell('AH6').alignment = { horizontal: 'center', wrapText: true }
      principal.getCell('AH6').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1bbec0' }, }
      principal.getCell('AH6').font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
      principal.getCell('AH6').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

      // principal.getRow('6').height = 40
      // principal.getColumn('A').width = 4
      // principal.getColumn('B').width = 13
      principal.getColumn('C').width = 10
      // principal.getColumn('D').width = 13
      // principal.getColumn('E').width = 7
      // principal.getColumn('F').width = 7
      // principal.getColumn('G').width = 15
      principal.getColumn('H').width = 20
      // principal.getColumn('I').width = 8
      // principal.getColumn('J').width = 4
      // principal.getColumn('K').width = 10
      // principal.getColumn('L').width = 10
      // principal.getColumn('M').width = 8
      // principal.getColumn('N').width = 15
      // principal.getColumn('O').width = 10
      // principal.getColumn('P').width = 10
      principal.getColumn('Q').width = 15
      principal.getColumn('R').width = 30
      // principal.getColumn('S').width = 10
      // principal.getColumn('T').width = 10
      // principal.getColumn('U').width = 10
      principal.getColumn('V').width = 4
      principal.getColumn('W').width = 4
      principal.getColumn('X').width = 4
      // principal.getColumn('Y').width = 10
      // principal.getColumn('Z').width = 10
      // principal.getColumn('T').width = 10
      // principal.getColumn('U').width = 10
      // principal.getColumn('V').width = 10

      // principal.getColumn('W').width = 10
      // principal.getColumn('X').width = 10
      // principal.getColumn('Z').width = 15
      // principal.getColumn('AA').width = 20
      // principal.getColumn('AB').width = 13
      // principal.getColumn('AC').width = 6






      let i = 8
      let j = 1
      for (let d of lista) {

        principal.getRow(i).height = 35

        principal.getCell(`A` + i).value = j
        principal.getCell(`B` + i).value = d.red_hospital
        principal.getCell(`C` + i).value = d.municipio_hospital
        principal.getCell(`D` + i).value = d.hospital
        principal.mergeCells('E' + i + ':F' + i)

        principal.getCell(`E` + i).value = d.medico_solicitante

        principal.getCell(`G` + i).value = d.fecha_solicitud.split('T')[0]
        principal.getCell(`H` + i).value = d.paciente
        principal.getCell(`I` + i).value = d.edad_años
        principal.getCell(`J` + i).value = d.edad_meses
        principal.getCell(`K` + i).value = d.edad_dias
        principal.getCell(`L` + i).value = d.grupo
        principal.getCell(`M` + i).value = d.grupo_etario
        principal.getCell(`N` + i).value = d.red_laboratorio
        principal.getCell(`O` + i).value = d.municipio_laboratorio
        principal.getCell(`P` + i).value = d.laboratorio
        principal.getCell(`Q` + i).value = d.medico_laboratorio
        principal.getCell(`R` + i).value = d.items_diagnostico
        principal.getCell(`S` + i).value = d.fecha_toma_muestra?.split('T')[0]
        principal.mergeCells('T' + i + ':U' + i)
        principal.getCell(`T` + i).value = parseInt(d.tipo_de_muestra) === 1 ? 'SANGRE TOTAL' : parseInt(d.tipo_de_muestra) === 2 ? 'SUERO' : parseInt(d.tipo_de_muestra) === 3 ? 'PLASMA' : parseInt(d.tipo_de_muestra) === 4 ? 'LCR' : ''
        principal.mergeCells('V' + i + ':X' + i)


        principal.getCell(`V` + i).value = parseInt(d.conclusion) === 1 ? 'POSITIVO' : parseInt(d.conclusion) === 2 ? 'NEGATIVO' : parseInt(d.conclusion) === 3 ? 'INDETERMINADO' : '-'
        // principal.getCell(`V` + i).value = parseInt(d.positivo) === 0 ? '-' : parseInt(d.positivo) === 1 ? 'SI' : parseInt(d.positivo) === 2 ? 'NO' : null

        // principal.getCell(`W` + i).value = parseInt(d.negativo) === 0 ? '-' : parseInt(d.negativo) === 1 ? 'SI' : parseInt(d.negativo) === 2 ? 'NO' : null
        // principal.getCell(`X` + i).value = parseInt(d.indeterminado) === 0 ? '-' : parseInt(d.indeterminado) === 1 ? 'SI' : parseInt(d.indeterminado) === 2 ? 'NO' : null
        principal.getCell(`Y` + i).value = d.fecha_registro_laboratorio?.split('T')[0]

        principal.getCell(`Z` + i).value = d.ultima_modificacion?.split('T')[0]
        principal.getCell(`AA` + i).value = d.pre_quirurgico

        principal.mergeCells('AB' + i + ':AC' + i)
        principal.getCell(`AB` + i).value = d.post_tratamiento

        principal.mergeCells('AD' + i + ':AF' + i)
        principal.getCell(`AD` + i).value = d.observaciones
        principal.getCell(`AG` + i).value = d.codigo
        principal.getCell(`AH` + i).value = d.cantidad_items_procesados



        principal.getCell(`A` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`B` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`C` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`D` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`E` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`G` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`H` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`I` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`J` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`K` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`L` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`M` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`N` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`O` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`P` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`Q` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`R` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`S` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`T` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`U` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`V` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`W` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`X` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`Y` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`Z` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`AA` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`AB` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`AC` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }


        principal.getCell(`AD` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`AE` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`AF` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`AG` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }
        principal.getCell(`AH` + i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' }, }




        principal.getCell(`A` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`B` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`C` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`D` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`E` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        principal.getCell(`G` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`H` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`I` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        principal.getCell(`J` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`K` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`L` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`M` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`N` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        // principal.getCell(`N` + i).alignment = { horizontal: 'center', wrapText: true };
        principal.getCell(`O` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };


        principal.getCell(`P` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`Q` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`R` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`S` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`T` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`U` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`V` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`W` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };


        principal.getCell(`X` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`Y` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`Z` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`AA` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        principal.getCell(`AB` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        principal.getCell(`AC` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        principal.getCell(`AD` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        principal.getCell(`AE` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        principal.getCell(`AF` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        principal.getCell(`AG` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };


        principal.getCell(`AH` + i).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };



        principal.getCell(`A` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`B` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`C` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`D` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`E` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`G` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`H` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`I` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`J` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`K` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`L` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`M` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`N` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`O` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`P` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`Q` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`R` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`S` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`T` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`U` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`V` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`W` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`X` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`Y` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`Z` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`AA` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`AB` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`AC` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`AD` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`AE` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`AF` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`AG` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell(`AH` + i).font = { size: 8, italic: false, color: { argb: "2c3e50" }, };
        principal.getCell('A' + i).alignment = { horizontal: 'center', vertical: 'distributed' }
        principal.getCell('J' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('K' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('L' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('M' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('U' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('W' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('X' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('Y' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('Z' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        principal.getCell('AH' + i).alignment = { horizontal: 'center', wrapText: true, vertical: 'distributed' }
        i++
        j++
      }


      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data], {
          type: "aplication/vnd.openxmlformats-officedocumets.spreadshhed.sheed",
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'BASE DE DATOS DX CHAGAS ACTUALIZADA' + ' ' + new Date().toLocaleDateString() + '.xlsx';
        anchor.click();
        window.URL.revokeObjectURL(url);
      })
    } else toast.error("no se encontraron datos")
  };


  return (
    <div className="contentSimple" >
      <div className="main-container">
        <Card>
          <CabeceraFormulariosTratamientoLista text={"GENERAR REPORTES"} />

          <CardBody>
            <p style={{ fontWeight: '700', fontSize: '16px', marginBottom: '0', fontStyle: 'oblique' }}>
              {" DIAGNOSTICOS"}
            </p>
            <Row>
            <Col md='4'>
                <InputUsuario
                  estado={inputBuscar}
                  cambiarEstado={setInputBuscar}
                  name="inputBuscar"
                  tipo={'date'}
                  ExpresionRegular={INPUT.FECHA} //expresion regular
                  etiqueta={"Fecha solicitud 1"}
                /></Col>
              <Col md='4'>
                <InputUsuario
                  estado={inputBuscar2}
                  cambiarEstado={setInputBuscar2}
                  name="inputBuscar"
                  tipo={'date'}
                  ExpresionRegular={INPUT.FECHA} //expresion regular
                  etiqueta={"Fecha solicitud 2"}
                />
              </Col>
 
              <Col md='6'>
                <Select1EasyColors
                  estado={idMunicipio}
                  cambiarEstado={setIdMunicipio}
                  ExpresionRegular={INPUT.ID}
                  lista={listaMunicipios}
                  name={"cv"}
                  etiqueta={"Municipio"}
                  msg="Seleccione una opcion"
                  nivel={setNivel}
                />
              </Col>


            </Row>
            <div style={{ borderBottom: '1px solid #E8F5F5', marginTop: '10px', marginBottom: '10px' }}>Parametros opcionales</div>
            <Row>
            <Col md='3'>
                <Select1
                  estado={realizados}
                  cambiarEstado={setRealizados}
                  ExpresionRegular={INPUT.ID}
                  name={"realizados"}
                  etiqueta={"Realizados"}
                  msg="Seleccione una opcion"
                  lista={[{ value: 1, label: 'Realizados' }, { value: 2, label: 'no realizados' },]}
                  importante={false}
                />
              </Col>
              <Col md='3'>
                <Select1
                  estado={idGrupo}
                  cambiarEstado={setIdGrupo}
                  ExpresionRegular={INPUT.ID}
                  lista={listaCronicoCongenito}
                  name={"cv"}
                  etiqueta={"congenito/cronico"}
                  msg="Seleccione una opcion"
                  funcion={listarGrupoEtario}
                  importante={false}
                />
              </Col>
              <Col md='3'>
                <Select1
                  estado={idGrupoEtario}
                  cambiarEstado={setIdGrupoEtario}
                  ExpresionRegular={INPUT.ID}
                  lista={listaGrupoEtario}
                  name={"cv"}
                  etiqueta={"Grupo Etario"}
                  msg="Seleccione una opcion"
                  importante={false}
                />
              </Col>
              <Col md='3'>
                <Select1
                  estado={idItem}
                  cambiarEstado={setIdItem}
                  ExpresionRegular={INPUT.ID}
                  lista={listaItemsDiagnostico}
                  name={"cv"}
                  etiqueta={"Item Diagnostico"}
                  msg="Seleccione una opcion"
                  importante={false}
                />
              </Col>
              <Col md={3}>
                <Select1
                  estado={sexo}
                  cambiarEstado={setSexo}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'SEXO'}
                  msg={"el formato no es valido"}
                  lista={[{ value: 1, label: 'Masculino' }, { value: 2, label: 'Femenino' }]}
                  name={'sexo'}
                  importante={false}
                />
              </Col>

              <Col md={3}>
                <Select1
                  estado={idTipoPaciente}
                  cambiarEstado={setIdTipoPaciente}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'TIPO PACIENTE'}
                  msg={"el formato no es valido"}
                  lista={listaTipoPaciente}
                  name={'id_tipo_paciente'}
                  importante={false}
                />
              </Col>

              <Col md='3'>
                <Select1
                  estado={idPreQuirurgico}
                  msg={"el formato no es valido"}
                  lista={[{ value: 1, label: 'Si' }, { value: 2, label: 'No' }]}
                  name={'id_prequirurgico'}
                  cambiarEstado={setIdPreQuirurgico}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'Prequirurgico'}
                  importante={false}
                />
              </Col>
              <Col md='3'>
                <Select1
                  estado={idPostTratamiento}
                  cambiarEstado={setIdPostTratamiento}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'PostTratamiento'}
                  msg={"el formato no es valido"}
                  lista={[{ value: 1, label: 'Si' }, { value: 2, label: 'No' }]}
                  name={'id_post_tratamiento'}
                  importante={false}
                />
              </Col>
              <Col md='3'>
                <Select1
                  estado={sangreTotal}
                  cambiarEstado={setSangreTotal}
                  ExpresionRegular={INPUT.ID}
                  name={"cv"}
                  etiqueta={"Tipo de muestra"}
                  msg="Seleccione una opcion"
                  lista={[{ value: 1, label: 'Sangre Total' }, { value: 2, label: 'Suero ' },{ value: 3, label: 'PLASMA ' },{ value: 4, label: 'LCR ' },]}
                  importante={false}
                />
              </Col>

            </Row>
            <Col md='12 ' style={{ display: 'flex', justifyContent: 'center', paddingTop: '0' }}>
              <button className="btn-reportes btn-info" style={{ marginTop: window.innerWidth < 768 ? '5px' : '24px', width: '100px' }} onClick={() => buscarPorHospital()} >
                GENERAR
              </button>
            </Col>

          </CardBody>

        </Card>
      </div>
    </div >
  );
}

